import { FrontendResponseErrorCode } from '../UserProfile/PasswordError.types';

export enum BackendAccountConfirmationErrorMessage {
  WrongToken = 'Błędny token',
  ExpiredAccount = 'Data ważności konta wygasła. Skontaktuj się z administratorem systemu.',
  ExpiredAccountMsgForAdmin = 'Data ważności konta wygasła.',
  WrongEmailCode = 'Błędny adres e-mail',
  WrongPesel = 'Niezgodny nr PESEL',
  WrongUserId = 'Błędny identyfikator użytkownika',
  EmailAlreadyConfirmed = 'Adres e-mail został już potwierdzony',
}

export enum BackendAccountConfirmationErrorCode {
  WrongToken = 'WrongToken',
  ExpiredAccount = 'ExpiredAccount',
  WrongEmail = 'WrongEmail',
  WrongPesel = 'WrongPesel',
  WrongUserId = 'WrongUserId',
  EmailAlreadyConfirmed = 'EmailAlreadyConfirmed',
}

export type ErrorAcountConfirmationCode = BackendAccountConfirmationErrorCode | FrontendResponseErrorCode;

export interface ResponseErrors {
  code: BackendAccountConfirmationErrorCode;
  descritiption: string;
}
